import moment from 'moment';
const LOCAL_STORAGE_KEYS = ['copyright_instName', 'copyright_nickname', 'copyright_avatar', 'copyright_search'];

let createCookie = (name, value, days) => {
	if (LOCAL_STORAGE_KEYS.includes(name)) {
		localStorage.setItem(name, value);
		return;
	}
	let expires = '';
	if (days) {
		let date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = ';expires=' + date.toGMTString();
	}
	try {
		document.cookie = name + '=' + value + expires + '; path=/';
	} catch (e) {
		//alert("cookie:"+e);
	}
};
let readCookie = name => {
	if (LOCAL_STORAGE_KEYS.includes(name)) {
		return localStorage.getItem(name);
	}
	try {
		let nameEQ = name + '=';
		let ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1, c.length);
			}
			if (c.indexOf(nameEQ) === 0) {
				return c.substring(nameEQ.length, c.length);
			}
		}
	} catch (e) {
		return null;
	}
	return null;
};
let _timeoutxxd = null;
let debounce = (callback, delay, param) => {
	if (typeof callback !== 'function') {
		return;
	}
	delay = delay || 150;
	if (_timeoutxxd) {
		window.clearTimeout(_timeoutxxd);
	}
	_timeoutxxd = window.setTimeout(function() {
		callback(param);
	}, delay);
};
let getQueryString = name => {
	let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	console.log('reg', reg);
	let r = window.location.search.substr(1).match(reg);
	if (r !== null) {
		return decodeURI(r[2]);
	}
	return null;
};
let getLocalQueryString = (url, name) => {
	let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	console.log('reg', reg);
	let r = url.substr(1).match(reg);
	if (r !== null) {
		return decodeURI(r[2]);
	}
	return null;
};
let base64ToBlob = code => {
	let parts = code.split(';base64,');
	let contentType = parts[0].split(':')[1];
	let raw = window.atob(parts[1]);
	let rawLength = raw.length;
	let uInt8Array = new Uint8Array(rawLength);
	for (let i = 0; i < rawLength; ++i) {
		uInt8Array[i] = raw.charCodeAt(i);
	}
	return new Blob([uInt8Array], {
		type: contentType
	});
};
let blobToFile = (theBlob, fileName) => {
	theBlob.lastModifiedDate = new Date();
	theBlob.name = fileName;
	return theBlob;
};
let blobToDataURL = (blob, callback) => {
	var fr = new FileReader();
	fr.onload = function(e) {
		callback(e.target.result);
	};
	fr.readAsDataURL(blob);
};
/**
 * phone
 */
let isPhone = phone => {
	if (!/^1[3456789]\d{9}$/.test(phone)) {
		return false;
	}
	return true;
};
/**
 * tel
 */
let isSpeialPlane = tel => {
	let t = tel.replace(/-/g, '');
	if (!/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(t)) {
		return false;
	}
	return true;
};
/**
 * width: 363
height: 450
 */
let formatImgWH = ({ boxWidth, boxHeight, actualWdith, actualHeight }) => {
	// width: 1500  600  width  (600/75)
	// height: 931   372  height
	let width = 0,
		height = 0;
	if (boxWidth >= actualWdith && boxHeight >= actualHeight) {
		width = actualWdith;
		height = actualHeight;
	} else if (actualWdith > boxWidth || actualHeight > boxHeight) {
		if (actualWdith > actualHeight) {
			height = boxHeight;
			width = (actualWdith / actualHeight) * boxHeight;
		} else {
			width = boxWidth;
			height = (actualHeight / actualWdith) * width;
		}
	}
	return {
		width,
		height
	};
};

function launchFullScreen() {
	// if (document.documentElement.requestFullscreen) {
	// 	return document.documentElement.requestFullscreen();
	// } else if (document.documentElement.mozRequestFullScreen) {
	// 	return document.documentElement.mozRequestFullScreen();
	// } else if (document.documentElement.webkitRequestFullscreen) {
	// 	return document.documentElement.webkitRequestFullscreen();
	// } else if (document.documentElement.msRequestFullscreen) {
	// 	return document.documentElement.msRequestFullscreen();
	// }
	return true;
}

/**
 * 微信
 */
function isWeixin(ua) {
	if (ua === undefined) {
		ua = navigator.userAgent;
	}
	ua = ua.toLowerCase();
	let res = ua.match(/MicroMessenger/i);
	if (res && res[0] === 'micromessenger' && ua.indexOf('wxwork') < 0) {
		return true;
	}
	return false;
}
/**
 * 企业微信
 */
function isWeixinWork() {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.indexOf('wxwork') >= 0) {
		return true;
	}
	return false;
}

function isVideoUrl(url) {
	let extensions = ['mp4', 'MP4', 'MOV', 'mov'];
	let extension = url.slice(url.lastIndexOf('.') + 1);
	return extensions.includes(extension);
}

function getPlatForm() {
	let userAgentInfo = window.navigator.userAgent;
	let Agents = ['Android', 'IOS', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
	if (Boolean(userAgentInfo.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/))) {
		return 'ios';
	}

	for (let v = 0; v < Agents.length; v++) {
		if (userAgentInfo.toLowerCase().indexOf(Agents[v].toLowerCase()) > 0) {
			return Agents[v];
		}
	}
	return 'PC';
}

function isPC() {
  let userAgentInfo = navigator.userAgent;
  let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

function isIOS() {
	return getPlatForm().toLowerCase() === 'ios';
}

function isAndroid() {
	let u = window.navigator.userAgent;
	return Boolean(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1);
}

// iPhone 在通过输入法的键盘上的收起箭头收起输入法时，输入框会失去焦点，因此会触发上面输入框的 blur 事件
// 但 Android 上并不会失去焦点，因此就不会触发 blur 事件。在 Android 上，要通过页面的 resize 事件来判断键盘的收起
function androidKeyboardHideEvent() {
	if (!isAndroid()) {
		// 调用该构造函数及其方法时不用再判断系统
		return {
			bind() {},
			unbind() {}
		};
	}

	return {
		winHeight: null,
		input: null,
		cb: null,
		handler() {
			setTimeout(() => {
				if (this.winHeight === window.innerHeight) {
					// 收起键盘
					this.cb && this.cb();
					this.input && this.input.blur();
				}
			});
		},

		// 如果传了第二个参数 input，则在失焦判定时会触发 input 的 blur 事件
		bind(cb, input) {
			this.winHeight = window.innerHeight;
			this.cb = cb;
			this.input = input;
			window.addEventListener('resize', this.handler.bind(this));
		},
		unbind() {
			window.removeEventListener('resize', this.handler);
		}
	};
}

function lockBody() {
	document.body.style.overflow = 'hidden';
	let tloader = document.querySelector('.tloader');
	let detailShare = document.querySelector('.detail-share');
	if (tloader) {
		tloader.style.overflowY = 'hidden';
	}
	if (detailShare) {
		detailShare.style.overflowY = 'hidden';
	}
}

function unLockBody() {
	document.body.style.overflow = 'auto';
	let tloader = document.querySelector('.tloader');
	let detailShare = document.querySelector('.detail-share');
	if (tloader) {
		tloader.style.overflowY = 'scroll';
	}
	if (detailShare) {
		detailShare.style.overflowY = 'scroll';
	}
}

function calcDate(val) {
	let isToday = new Date(val).toDateString() === new Date().toDateString();
	if (isToday) {
		let timeDifference = new Date().getTime() - val;
		if (timeDifference/1000/60/60 > 1) {
			return Math.ceil(timeDifference/1000/60/60) + "小时前";
		}
		if (timeDifference/1000/60 > 1) {
			return Math.ceil(timeDifference/1000/60) + "分钟前";
		}
		if (timeDifference/1000 > 1) {
			return Math.ceil(timeDifference/1000) + "秒前";
		}
	} else {
		return moment(val).format('YYYY年MM月DD日');
	}
}

export {
	createCookie,
	readCookie,
	debounce,
	getQueryString,
	getLocalQueryString,
	base64ToBlob,
	blobToDataURL,
	blobToFile,
	isPhone,
	isSpeialPlane,
	formatImgWH,
	launchFullScreen,
	isWeixin,
	isWeixinWork,
	isVideoUrl,
	getPlatForm,
	isPC,
	isIOS,
	isAndroid,
	androidKeyboardHideEvent,
	lockBody,
	unLockBody,
	calcDate
};
